import EditHotel from "./EditHotel";

export default EditHotel;
